(function () {
    'ngInject';

    angular.module('app.shared.services').factory('CutoutProAPIService', cutoutProAPIService);

    function cutoutProAPIService(HttpService) {
        const baseURL = 'https://www.cutout.pro/api/v1';
        const INVALID_API_KEY_CODE = 5002;

        async function isValidAPIKey(key) {
            const config = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    APIKEY: key,
                    Accept: 'application/json'
                },
                cache: 'no-store'
            };

            try {
                const response = await fetch(baseURL + '/mySubscription', config);
                const data = await response.json();
                return data.code != INVALID_API_KEY_CODE;
            } catch (error) {
                throw error;
            }
        }

        async function cutoutFace(key, image, cutFace, isPreview = false) {
            const preview = isPreview ? '&preview=true' : '';
            let filterSufix = `/matting?mattingType=3&crop=true${preview}`;
            if (cutFace === false) {
                filterSufix = `/matting?mattingType=6&crop=true${preview}`;
            }

            const formData = new FormData();
            formData.append('file', image);

            try {
                const response = await fetch(baseURL + filterSufix, {
                    method: 'POST',
                    headers: { APIKEY: key },
                    body: formData
                });

                if (!response.ok || response.headers.get('Content-Type') !== 'image/png') {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.blob();
            } catch (error) {
                throw error;
            }
        }

        return {
            cutoutFace,
            isValidAPIKey
        };
    }
})();
